var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolioBgRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 828,
    height: 3233,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827 2592.39C725.32 2592.39 642.891 2674.7 642.891 2776.23C642.891 2877.77 725.32 2960.35 827 2960.35",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2585.08C733.454 2585.08 657.533 2667.39 657.533 2768.92C657.533 2870.46 733.454 2952.77 827 2952.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2577.77C741.589 2577.77 672.175 2660.08 672.175 2761.61C672.175 2863.14 741.589 2945.73 827 2945.73",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2570.46C749.723 2570.46 687.088 2652.77 687.088 2754.3C687.088 2855.83 749.723 2938.14 827 2938.14",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2562.87C757.857 2562.87 701.73 2645.18 701.73 2746.72C701.73 2848.25 757.857 2930.83 827 2930.83",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2555.56C765.992 2555.56 716.372 2637.87 716.372 2739.41C716.372 2840.94 765.992 2923.52 827 2923.52",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2548.25C774.126 2548.25 731.285 2630.56 731.285 2732.1C731.285 2833.63 774.126 2916.21 827 2916.21",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2540.94C782.261 2540.94 745.927 2623.25 745.927 2724.79C745.927 2826.32 782.261 2908.9 827 2908.9",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2533.63C790.395 2533.63 760.569 2615.94 760.569 2717.48C760.569 2819.01 790.395 2901.32 827 2901.32",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2526.32C798.529 2526.32 775.482 2608.63 775.482 2710.17C775.482 2811.7 798.53 2894.01 827 2894.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2518.74C806.664 2518.74 790.124 2601.05 790.124 2702.59C790.124 2804.12 806.664 2886.7 827 2886.7",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2511.43C814.798 2511.43 804.766 2593.74 804.766 2695.27C804.766 2796.81 814.798 2879.39 827 2879.39",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2776.5C725.32 2776.5 642.891 2694.19 642.891 2592.66C642.891 2491.12 725.32 2408.54 827 2408.54",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2783.81C733.454 2783.81 657.533 2701.5 657.533 2599.97C657.533 2498.43 733.454 2416.12 827 2416.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2791.12C741.589 2791.12 672.175 2708.81 672.175 2607.28C672.175 2505.74 741.589 2423.16 827 2423.16",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2798.43C749.723 2798.43 687.088 2716.12 687.088 2614.59C687.088 2513.05 749.723 2430.47 827 2430.47",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2805.74C757.857 2805.74 701.73 2723.43 701.73 2621.9C701.73 2520.36 757.857 2437.78 827 2437.78",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2813.05C765.992 2813.05 716.372 2730.74 716.372 2629.21C716.372 2527.68 765.992 2445.36 827 2445.36",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2820.64C774.126 2820.64 731.285 2738.33 731.285 2636.79C731.285 2535.26 774.126 2452.68 827 2452.68",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2827.95C782.261 2827.95 745.927 2745.64 745.927 2644.1C745.927 2542.57 782.261 2459.99 827 2459.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2835.26C790.395 2835.26 760.569 2752.95 760.569 2651.41C760.569 2549.88 790.395 2467.57 827 2467.57",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2842.57C798.53 2842.57 775.482 2760.26 775.482 2658.72C775.482 2557.19 798.529 2474.88 827 2474.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2849.88C806.664 2849.88 790.124 2767.57 790.124 2666.03C790.124 2564.5 806.664 2481.92 827 2481.92",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2857.19C814.798 2857.19 804.766 2774.88 804.766 2673.34C804.766 2571.81 814.798 2489.5 827 2489.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2864.77C822.933 2864.77 819.679 2782.46 819.679 2680.92C819.679 2579.39 822.933 2496.81 827 2496.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2504.12C822.933 2504.12 819.679 2586.43 819.679 2687.96C819.679 2758.09 821.306 2819.01 823.475 2850.15",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3144.19C725.32 3144.19 642.891 3061.88 642.891 2960.35C642.891 2858.81 725.32 2776.5 827 2776.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3151.77C733.454 3151.77 657.533 3069.19 657.533 2967.66C657.533 2866.12 733.454 2783.81 827 2783.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3159.08C741.589 3159.08 672.175 3076.77 672.175 2975.24C672.175 2873.7 741.589 2791.12 827 2791.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3166.39C749.723 3166.39 687.088 3084.08 687.088 2982.55C687.088 2881.01 749.723 2798.43 827 2798.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3173.7C757.857 3173.7 701.73 3091.39 701.73 2989.86C701.73 2888.33 757.857 2805.74 827 2805.74",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3181.01C765.992 3181.01 716.372 3098.7 716.372 2997.17C716.372 2895.64 765.992 2813.05 827 2813.05",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3188.33C774.126 3188.33 731.285 3106.01 731.285 3004.48C731.285 2902.95 774.126 2820.64 827 2820.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3195.91C782.261 3195.91 745.927 3113.6 745.927 3012.06C745.927 2910.53 782.261 2827.95 827 2827.95",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3203.22C790.395 3203.22 760.569 3120.91 760.569 3019.1C760.569 2917.3 790.395 2835.26 827 2835.26",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3210.53C798.53 3210.53 775.482 3128.22 775.482 3026.68C775.482 2925.15 798.529 2842.84 827 2842.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3217.84C806.664 3217.84 790.124 3135.53 790.124 3033.99C790.124 2932.46 806.664 2849.88 827 2849.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3225.15C814.798 3225.15 804.766 3142.84 804.766 3041.3C804.766 2939.77 814.798 2857.19 827 2857.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 3232.46C822.933 3232.46 819.679 3150.15 819.679 3048.61C819.679 2947.08 822.933 2864.77 827 2864.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2872.08C822.933 2872.08 819.679 2954.39 819.679 3055.92C819.679 3126.05 821.306 3186.97 823.475 3218.11",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2320.61C725.32 2320.61 642.891 2238.3 642.891 2136.77C642.891 2035.23 725.32 1952.65 827 1952.65",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2327.92C733.454 2327.92 657.533 2245.61 657.533 2144.08C657.533 2042.55 733.454 1960.23 827 1960.23",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2335.23C741.589 2335.23 672.175 2252.92 672.175 2151.39C672.175 2049.86 741.589 1967.27 827 1967.27",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2342.55C749.723 2342.55 687.088 2260.23 687.088 2158.7C687.088 2057.17 749.723 1974.86 827 1974.86",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2350.13C757.857 2350.13 701.73 2267.82 701.73 2166.28C701.73 2064.75 757.857 1982.17 827 1982.17",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2357.44C765.992 2357.44 716.372 2275.13 716.372 2173.59C716.372 2072.06 765.992 1989.48 827 1989.48",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2364.75C774.126 2364.75 731.285 2282.44 731.285 2180.9C731.285 2079.37 774.126 1996.79 827 1996.79",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2372.06C782.261 2372.06 745.927 2289.75 745.927 2188.21C745.927 2086.68 782.261 2004.1 827 2004.1",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2379.37C790.395 2379.37 760.569 2297.06 760.569 2195.52C760.569 2093.99 790.395 2011.68 827 2011.68",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2386.68C798.529 2386.68 775.482 2304.37 775.482 2202.83C775.482 2101.3 798.53 2018.99 827 2018.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2394.26C806.664 2394.26 790.124 2311.95 790.124 2210.42C790.124 2108.88 806.664 2026.3 827 2026.3",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2401.57C814.798 2401.57 804.766 2319.26 804.766 2217.73C804.766 2116.19 814.798 2033.61 827 2033.61",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2136.5C725.32 2136.5 642.891 2218.81 642.891 2320.34C642.891 2421.88 725.32 2504.46 827 2504.46",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2129.19C733.454 2129.19 657.533 2211.5 657.533 2313.03C657.533 2414.57 733.454 2496.88 827 2496.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2121.88C741.589 2121.88 672.175 2204.19 672.175 2305.72C672.175 2407.26 741.589 2489.84 827 2489.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2114.57C749.723 2114.57 687.088 2196.88 687.088 2298.41C687.088 2399.95 749.723 2482.53 827 2482.53",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2107.26C757.857 2107.26 701.73 2189.57 701.73 2291.1C701.73 2392.64 757.857 2475.22 827 2475.22",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2099.95C765.992 2099.95 716.372 2182.26 716.372 2283.79C716.372 2385.33 765.992 2467.64 827 2467.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2092.36C774.126 2092.36 731.285 2174.68 731.285 2276.21C731.285 2377.74 774.126 2460.33 827 2460.33",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2085.05C782.261 2085.05 745.927 2167.37 745.927 2268.9C745.927 2370.43 782.261 2453.01 827 2453.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2077.74C790.395 2077.74 760.569 2160.05 760.569 2261.59C760.569 2363.12 790.395 2445.43 827 2445.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2070.43C798.53 2070.43 775.482 2152.74 775.482 2254.28C775.482 2355.81 798.529 2438.12 827 2438.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2063.12C806.664 2063.12 790.124 2145.43 790.124 2246.97C790.124 2348.5 806.664 2431.08 827 2431.08",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2055.81C814.798 2055.81 804.766 2138.12 804.766 2239.66C804.766 2341.19 814.798 2423.5 827 2423.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2048.23C822.933 2048.23 819.679 2130.54 819.679 2232.08C819.679 2333.61 822.933 2416.19 827 2416.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2408.88C822.933 2408.88 819.679 2326.57 819.679 2225.04C819.679 2154.91 821.306 2093.99 823.475 2062.85",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1768.81C725.32 1768.81 642.891 1851.12 642.891 1952.65C642.891 2054.19 725.32 2136.5 827 2136.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1761.23C733.454 1761.23 657.533 1843.81 657.533 1945.34C657.533 2046.88 733.454 2129.19 827 2129.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1753.92C741.589 1753.92 672.175 1836.23 672.175 1937.76C672.175 2039.3 741.589 2121.88 827 2121.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1746.61C749.723 1746.61 687.088 1828.92 687.088 1930.45C687.088 2031.99 749.723 2114.57 827 2114.57",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1739.3C757.857 1739.3 701.73 1821.61 701.73 1923.14C701.73 2024.68 757.857 2107.26 827 2107.26",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1731.99C765.992 1731.99 716.372 1814.3 716.372 1915.83C716.372 2017.36 765.992 2099.95 827 2099.95",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1724.68C774.126 1724.68 731.285 1806.99 731.285 1908.52C731.285 2010.05 774.126 2092.36 827 2092.36",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1717.09C782.261 1717.09 745.927 1799.4 745.927 1900.94C745.927 2002.47 782.261 2085.05 827 2085.05",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1709.78C790.395 1709.78 760.569 1792.09 760.569 1893.9C760.569 1995.7 790.395 2077.74 827 2077.74",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1702.47C798.53 1702.47 775.482 1784.78 775.482 1886.32C775.482 1987.85 798.529 2070.16 827 2070.16",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1695.16C806.664 1695.16 790.124 1777.47 790.124 1879.01C790.124 1980.54 806.664 2063.12 827 2063.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1687.85C814.798 1687.85 804.766 1770.16 804.766 1871.7C804.766 1973.23 814.798 2055.81 827 2055.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1680.54C822.933 1680.54 819.679 1762.85 819.679 1864.39C819.679 1965.92 822.933 2048.23 827 2048.23",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2040.92C822.933 2040.92 819.679 1958.61 819.679 1857.08C819.679 1786.95 821.306 1726.03 823.475 1694.89",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1408.39C725.32 1408.39 642.891 1490.7 642.891 1592.23C642.891 1693.77 725.32 1776.35 827 1776.35",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1401.08C733.454 1401.08 657.533 1483.39 657.533 1584.92C657.533 1686.46 733.454 1768.77 827 1768.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1393.77C741.589 1393.77 672.175 1476.08 672.175 1577.61C672.175 1679.14 741.589 1761.73 827 1761.73",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1386.46C749.723 1386.46 687.088 1468.77 687.088 1570.3C687.088 1671.83 749.723 1754.14 827 1754.14",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1378.87C757.857 1378.87 701.73 1461.18 701.73 1562.72C701.73 1664.25 757.857 1746.83 827 1746.83",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1371.56C765.992 1371.56 716.372 1453.87 716.372 1555.41C716.372 1656.94 765.992 1739.52 827 1739.52",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1364.25C774.126 1364.25 731.285 1446.56 731.285 1548.1C731.285 1649.63 774.126 1732.21 827 1732.21",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1356.94C782.261 1356.94 745.927 1439.25 745.927 1540.79C745.927 1642.32 782.261 1724.9 827 1724.9",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1349.63C790.395 1349.63 760.569 1431.94 760.569 1533.48C760.569 1635.01 790.395 1717.32 827 1717.32",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1342.32C798.529 1342.32 775.482 1424.63 775.482 1526.17C775.482 1627.7 798.53 1710.01 827 1710.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1334.74C806.664 1334.74 790.124 1417.05 790.124 1518.59C790.124 1620.12 806.664 1702.7 827 1702.7",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1327.43C814.798 1327.43 804.766 1409.74 804.766 1511.27C804.766 1612.81 814.798 1695.39 827 1695.39",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1592.5C725.32 1592.5 642.891 1510.19 642.891 1408.66C642.891 1307.12 725.32 1224.54 827 1224.54",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1599.81C733.454 1599.81 657.533 1517.5 657.533 1415.97C657.533 1314.43 733.454 1232.12 827 1232.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1607.12C741.589 1607.12 672.175 1524.81 672.175 1423.28C672.175 1321.74 741.589 1239.16 827 1239.16",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1614.43C749.723 1614.43 687.088 1532.12 687.088 1430.59C687.088 1329.05 749.723 1246.47 827 1246.47",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1621.74C757.857 1621.74 701.73 1539.43 701.73 1437.9C701.73 1336.36 757.857 1253.78 827 1253.78",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1629.05C765.992 1629.05 716.372 1546.74 716.372 1445.21C716.372 1343.68 765.992 1261.36 827 1261.36",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1636.64C774.126 1636.64 731.285 1554.33 731.285 1452.79C731.285 1351.26 774.126 1268.68 827 1268.68",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1643.95C782.261 1643.95 745.927 1561.64 745.927 1460.1C745.927 1358.57 782.261 1275.99 827 1275.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1651.26C790.395 1651.26 760.569 1568.95 760.569 1467.41C760.569 1365.88 790.395 1283.57 827 1283.57",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1658.57C798.53 1658.57 775.482 1576.26 775.482 1474.72C775.482 1373.19 798.529 1290.88 827 1290.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1665.88C806.664 1665.88 790.124 1583.57 790.124 1482.03C790.124 1380.5 806.664 1297.92 827 1297.92",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1673.19C814.798 1673.19 804.766 1590.88 804.766 1489.34C804.766 1387.81 814.798 1305.5 827 1305.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1680.77C822.933 1680.77 819.679 1598.46 819.679 1496.92C819.679 1395.39 822.933 1312.81 827 1312.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1320.12C822.933 1320.12 819.679 1402.43 819.679 1503.96C819.679 1574.09 821.306 1635.01 823.475 1666.15",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1960.19C725.32 1960.19 642.891 1877.88 642.891 1776.35C642.891 1674.81 725.32 1592.5 827 1592.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1967.77C733.454 1967.77 657.533 1885.19 657.533 1783.66C657.533 1682.12 733.454 1599.81 827 1599.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1975.08C741.589 1975.08 672.175 1892.77 672.175 1791.24C672.175 1689.7 741.589 1607.12 827 1607.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1982.39C749.723 1982.39 687.088 1900.08 687.088 1798.55C687.088 1697.01 749.723 1614.43 827 1614.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1989.7C757.857 1989.7 701.73 1907.39 701.73 1805.86C701.73 1704.33 757.857 1621.74 827 1621.74",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1997.01C765.992 1997.01 716.372 1914.7 716.372 1813.17C716.372 1711.64 765.992 1629.05 827 1629.05",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2004.33C774.126 2004.33 731.285 1922.01 731.285 1820.48C731.285 1718.95 774.126 1636.64 827 1636.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2011.91C782.261 2011.91 745.927 1929.6 745.927 1828.06C745.927 1726.53 782.261 1643.95 827 1643.95",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2019.22C790.395 2019.22 760.569 1936.91 760.569 1835.1C760.569 1733.3 790.395 1651.26 827 1651.26",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2026.53C798.53 2026.53 775.482 1944.22 775.482 1842.68C775.482 1741.15 798.529 1658.84 827 1658.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2033.84C806.664 2033.84 790.124 1951.53 790.124 1849.99C790.124 1748.46 806.664 1665.88 827 1665.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2041.15C814.798 2041.15 804.766 1958.84 804.766 1857.3C804.766 1755.77 814.798 1673.19 827 1673.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 2048.46C822.933 2048.46 819.679 1966.15 819.679 1864.61C819.679 1763.08 822.933 1680.77 827 1680.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1688.08C822.933 1688.08 819.679 1770.39 819.679 1871.92C819.679 1942.05 821.306 2002.97 823.475 2034.11",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1136.61C725.32 1136.61 642.891 1054.3 642.891 952.769C642.891 851.235 725.32 768.654 827 768.654",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1143.92C733.454 1143.92 657.533 1061.61 657.533 960.08C657.533 858.546 733.454 776.235 827 776.235",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1151.23C741.589 1151.23 672.175 1068.92 672.175 967.39C672.175 865.856 741.589 783.275 827 783.275",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1158.55C749.723 1158.55 687.088 1076.24 687.088 974.701C687.088 873.166 749.723 790.856 827 790.856",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1166.13C757.857 1166.13 701.73 1083.82 701.73 982.282C701.73 880.748 757.857 798.166 827 798.167",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1173.44C765.992 1173.44 716.372 1091.13 716.372 989.592C716.372 888.058 765.992 805.477 827 805.477",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1180.75C774.126 1180.75 731.285 1098.44 731.285 996.903C731.285 895.369 774.126 812.787 827 812.787",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1188.06C782.261 1188.06 745.927 1105.75 745.927 1004.21C745.927 902.679 782.261 820.098 827 820.098",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1195.37C790.395 1195.37 760.569 1113.06 760.569 1011.52C760.569 909.989 790.395 827.679 827 827.679",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1202.68C798.529 1202.68 775.482 1120.37 775.482 1018.83C775.482 917.3 798.53 834.989 827 834.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1210.26C806.664 1210.26 790.124 1127.95 790.124 1026.42C790.124 924.881 806.664 842.3 827 842.3",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1217.57C814.798 1217.57 804.766 1135.26 804.766 1033.73C804.766 932.192 814.798 849.611 827 849.611",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 952.499C725.32 952.499 642.891 1034.81 642.891 1136.34C642.891 1237.88 725.32 1320.46 827 1320.46",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 945.188C733.454 945.188 657.533 1027.5 657.533 1129.03C657.533 1230.57 733.454 1312.88 827 1312.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 937.877C741.589 937.877 672.175 1020.19 672.175 1121.72C672.175 1223.26 741.589 1305.84 827 1305.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 930.567C749.723 930.567 687.088 1012.88 687.088 1114.41C687.088 1215.95 749.723 1298.53 827 1298.53",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 923.257C757.857 923.257 701.73 1005.57 701.73 1107.1C701.73 1208.64 757.857 1291.22 827 1291.22",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 915.946C765.992 915.946 716.372 998.256 716.372 1099.79C716.372 1201.33 765.992 1283.64 827 1283.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 908.365C774.126 908.365 731.285 990.675 731.285 1092.21C731.285 1193.74 774.126 1276.33 827 1276.33",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 901.054C782.261 901.054 745.927 983.365 745.927 1084.9C745.927 1186.43 782.261 1269.01 827 1269.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 893.744C790.395 893.744 760.569 976.054 760.569 1077.59C760.569 1179.12 790.395 1261.43 827 1261.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 886.433C798.53 886.433 775.482 968.744 775.482 1070.28C775.482 1171.81 798.529 1254.12 827 1254.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 879.123C806.664 879.123 790.124 961.434 790.124 1062.97C790.124 1164.5 806.664 1247.08 827 1247.08",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 871.812C814.798 871.812 804.766 954.123 804.766 1055.66C804.766 1157.19 814.798 1239.5 827 1239.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 864.231C822.933 864.231 819.679 946.542 819.679 1048.08C819.679 1149.61 822.933 1232.19 827 1232.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 1224.88C822.933 1224.88 819.679 1142.57 819.679 1041.04C819.679 970.91 821.306 909.989 823.475 878.852",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 584.809C725.32 584.809 642.891 667.12 642.891 768.654C642.891 870.188 725.32 952.499 827 952.499",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 577.228C733.454 577.228 657.533 659.809 657.533 761.343C657.533 862.878 733.454 945.188 827 945.188",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 569.917C741.589 569.917 672.175 652.228 672.175 753.762C672.175 855.296 741.589 937.878 827 937.878",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 562.607C749.723 562.607 687.088 644.917 687.088 746.451C687.088 847.986 749.723 930.567 827 930.567",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 555.296C757.857 555.296 701.73 637.607 701.73 739.141C701.73 840.675 757.857 923.257 827 923.257",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 547.986C765.992 547.986 716.372 630.296 716.372 731.831C716.372 833.365 765.992 915.946 827 915.946",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 540.675C774.126 540.675 731.285 622.986 731.285 724.52C731.285 826.054 774.126 908.365 827 908.365",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 533.094C782.261 533.094 745.927 615.405 745.927 716.939C745.927 818.473 782.261 901.055 827 901.055",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 525.784C790.395 525.784 760.569 608.094 760.569 709.899C760.569 811.704 790.395 893.744 827 893.744",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 518.473C798.53 518.473 775.482 600.784 775.482 702.318C775.482 803.852 798.529 886.163 827 886.163",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 511.163C806.664 511.163 790.124 593.473 790.124 695.008C790.124 796.542 806.664 879.123 827 879.123",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 503.852C814.798 503.852 804.766 586.163 804.766 687.697C804.766 789.231 814.798 871.813 827 871.813",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 496.542C822.933 496.542 819.679 578.852 819.679 680.387C819.679 781.921 822.933 864.231 827 864.231",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 856.921C822.933 856.921 819.679 774.61 819.679 673.076C819.679 602.95 821.306 542.029 823.475 510.892",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 224.386C725.32 224.386 642.891 306.697 642.891 408.231C642.891 509.765 725.32 592.347 827 592.347",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 217.076C733.454 217.076 657.533 299.386 657.533 400.921C657.533 502.455 733.454 584.765 827 584.765",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 209.766C741.589 209.766 672.175 292.076 672.175 393.61C672.175 495.145 741.589 577.726 827 577.726",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 202.455C749.723 202.455 687.088 284.765 687.088 386.3C687.088 487.834 749.723 570.145 827 570.145",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 194.874C757.857 194.874 701.73 277.184 701.73 378.718C701.73 480.253 757.857 562.834 827 562.834",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 187.563C765.992 187.563 716.372 269.874 716.372 371.408C716.372 472.942 765.992 555.524 827 555.524",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 180.253C774.126 180.253 731.285 262.563 731.285 364.098C731.285 465.632 774.126 548.213 827 548.213",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 172.942C782.261 172.942 745.927 255.253 745.927 356.787C745.927 458.321 782.261 540.903 827 540.903",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 165.632C790.395 165.632 760.569 247.942 760.569 349.477C760.569 451.011 790.395 533.322 827 533.322",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 158.321C798.529 158.321 775.482 240.632 775.482 342.166C775.482 443.7 798.53 526.011 827 526.011",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 150.74C806.664 150.74 790.124 233.051 790.124 334.585C790.124 436.119 806.664 518.7 827 518.7",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 143.43C814.798 143.43 804.766 225.74 804.766 327.274C804.766 428.809 814.798 511.39 827 511.39",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 408.502C725.32 408.502 642.891 326.192 642.891 224.657C642.891 123.123 725.32 40.5416 827 40.5416",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 415.812C733.454 415.813 657.533 333.502 657.533 231.968C657.533 130.433 733.454 48.1229 827 48.1229",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 423.123C741.589 423.123 672.175 340.813 672.175 239.278C672.175 137.744 741.589 55.1627 827 55.1627",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 430.434C749.723 430.434 687.088 348.123 687.088 246.589C687.088 145.055 749.723 62.4733 827 62.4733",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 437.744C757.857 437.744 701.73 355.433 701.73 253.899C701.73 152.365 757.857 69.7836 827 69.7836",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 445.054C765.992 445.054 716.372 362.744 716.372 261.21C716.372 159.675 765.992 77.3649 827 77.3649",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 452.636C774.126 452.636 731.285 370.325 731.285 268.791C731.285 167.257 774.126 84.6754 827 84.6754",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 459.946C782.261 459.946 745.927 377.636 745.927 276.101C745.927 174.567 782.261 91.9857 827 91.9857",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 467.257C790.395 467.257 760.569 384.946 760.569 283.412C760.569 181.877 790.395 99.567 827 99.567",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 474.567C798.53 474.567 775.482 392.257 775.482 290.722C775.482 189.188 798.529 106.878 827 106.878",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 481.877C806.664 481.877 790.124 399.567 790.124 298.033C790.124 196.498 806.664 113.917 827 113.917",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 489.188C814.798 489.188 804.766 406.878 804.766 305.343C804.766 203.809 814.798 121.498 827 121.498",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 496.769C822.933 496.769 819.679 414.459 819.679 312.925C819.679 211.39 822.933 128.809 827 128.809",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 136.119C822.933 136.119 819.679 218.43 819.679 319.964C819.679 390.091 821.306 451.011 823.475 482.148",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 776.191C725.32 776.191 642.891 693.881 642.891 592.347C642.891 490.812 725.32 408.502 827 408.502",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 783.773C733.454 783.773 657.533 701.191 657.533 599.657C657.533 498.123 733.454 415.812 827 415.812",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 791.083C741.589 791.083 672.175 708.773 672.175 607.238C672.175 505.704 741.589 423.123 827 423.123",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 798.394C749.723 798.394 687.088 716.083 687.088 614.549C687.088 513.015 749.723 430.433 827 430.433",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 805.704C757.857 805.704 701.73 723.394 701.73 621.859C701.73 520.325 757.857 437.744 827 437.744",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 813.015C765.992 813.015 716.372 730.704 716.372 629.17C716.372 527.636 765.992 445.054 827 445.054",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 820.325C774.126 820.325 731.285 738.015 731.285 636.48C731.285 534.946 774.126 452.636 827 452.636",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 827.906C782.261 827.906 745.927 745.596 745.927 644.061C745.927 542.527 782.261 459.946 827 459.946",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 835.217C790.395 835.217 760.569 752.906 760.569 651.101C760.569 549.296 790.395 467.256 827 467.256",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 842.527C798.53 842.527 775.482 760.217 775.482 658.683C775.482 557.148 798.529 474.838 827 474.838",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 849.838C806.664 849.838 790.124 767.527 790.124 665.993C790.124 564.459 806.664 481.877 827 481.877",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 857.148C814.798 857.148 804.766 774.838 804.766 673.303C804.766 571.769 814.798 489.188 827 489.188",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 864.459C822.933 864.459 819.679 782.148 819.679 680.614C819.679 579.08 822.933 496.769 827 496.769",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 504.08C822.933 504.08 819.679 586.39 819.679 687.925C819.679 758.051 821.306 818.971 823.475 850.109",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBgRight);
export default __webpack_public_path__ + "static/media/portfolio-bg-right.7624c263ded4bbc9e13a04e64872b6ad.svg";
export { ForwardRef as ReactComponent };